import { useI18n } from "@wojo/localization";
import { Text } from "@wojo/ui";
import React, { useId } from "react";
import { useTourPageContext } from "../../_client/context";
import { TourSectionId } from "../../_client/hooks";
import styles from "./Overview.module.scss";
import { OverviewColumn } from "./OverviewColumn";
import { SpecialDeparturesBanner } from "./SpecialDeparturesBanner";

export const Overview: React.FC = () => {
    const { colorPalette, tourContent, specialDepartures } =
        useTourPageContext();
    const titleId = useId();
    const { productPage } = useI18n("productPage");
    const backgroundColor = `var(--s-color-${colorPalette}-quiet)`;

    return (
        <section
            aria-labelledby={titleId}
            className={styles.section}
            id={TourSectionId.OVERVIEW}
            tabIndex={-1}
        >
            <Text.Heading
                order="3"
                tag="h2"
                id={titleId}
                style={{ marginBottom: "var(--g-spacing-sm)" }}
            >
                {tourContent.overviewTitle || productPage.overview.heading.l()}
            </Text.Heading>
            <Text.Body style={{ marginBottom: "var(--g-spacing-md)" }}>
                {tourContent.overviewDescription}
            </Text.Body>
            <SpecialDeparturesBanner
                backgroundColor={backgroundColor}
                specialDepartures={specialDepartures}
            />
            <div className={styles["overview-columns"]}>
                <OverviewColumn
                    title={productPage.overview.inclusions.heading.l()}
                    items={tourContent.inclusions
                        .map((item) => item.text)
                        .filter((item): item is string => !!item)}
                />
                <OverviewColumn
                    title={productPage.overview.highlights.heading.l()}
                    items={tourContent.highlights
                        .map((item) => item.text)
                        .filter((item): item is string => !!item)}
                />
            </div>
        </section>
    );
};
